import React, { FC, useCallback, useEffect, useRef } from "react";
import { useState } from "react";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import FormHelperText from "@mui/material/FormHelperText";
import Alert from "@mui/material/Alert";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import Autocomplete from "@mui/material/Autocomplete";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import PercentIcon from "@mui/icons-material/Percent";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import {
  CircularProgress,
  Grid,
  InputAdornment,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import Paper from "@mui/material/Paper";
import { advertisingAccountsEndPointLogic } from "../../../../logic/PaidTrafficManagement/AdvertisingAccounts/AdvertisingAccounts/advertisingAccountsEndPointLogic";
import { Box, Stack } from "@mui/system";
import ReplayOutlinedIcon from "@mui/icons-material/ReplayOutlined";
import { trackPromise } from "react-promise-tracker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateRangePicker } from "@mui/x-date-pickers-pro/DateRangePicker";
import { SingleInputDateRangeField } from "@mui/x-date-pickers-pro/SingleInputDateRangeField";
import "../../PaidTraffic.css";
import dayjs, { Dayjs } from "dayjs";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";

interface CreateAccountDialogProps {
  open: boolean;
  handleClose: () => void;
  adAccountDetails: any;
  selectedSource: any;
  adAccountGeoDetails: any;
  adAccountIndustryDetails: any;
  oauthTokenHeader: string;
  mergedAssets: any;
  adAccountTerritoryDetails: any;
  setAdAccountId: any;
  adAccountId: any;
  handleCloseRetrieve: any;
  setReloadAfterToggleEdit: any;
  setAdAccLength: any;
  setAdAccountDetails: any;
  setSelectedSource: any;
  createAccRes: any;
  setCreateAccRes: any;
  setShowCreateAccountDialog: any;
  errorSnackbarOpen: any;
  websitePermissions: any;
  setErrorSnackbarOpen: any;
  getAdAccountDetails: Function;
  siteNames: any;
  setDialogOpen: any;
  fetchAdAccountData: any;
  isSimplifiedFlow: any;
  setIsSimplifiedFlow: any;
  getAdAccountDetailsByClick: any;
  convLoading: any;
  selectedCompany: any;
}

type AdAccountCreateResponse = {
  shared_uid: string;
  // Other properties, if any
};

type errorTextWhileCreate = {
  text: string;
};

type DivItem = {
  id: number;
  assetType: string;
  assetName: string;
  startDate: Dayjs | null;
  endDate: Dayjs | null;
  disabled: boolean;
};

const CreateAccountDialog: FC<CreateAccountDialogProps> = ({
  siteNames,
  getAdAccountDetailsByClick,
  setErrorSnackbarOpen,
  // errorSnackbarOpen,
  // setShowCreateAccountDialog,
  setCreateAccRes,
  createAccRes,
  setSelectedSource,
  setAdAccountDetails,
  setAdAccLength,
  setReloadAfterToggleEdit,
  handleCloseRetrieve,
  setAdAccountId,
  handleClose,
  adAccountDetails,
  selectedSource,
  adAccountGeoDetails,
  adAccountIndustryDetails,
  oauthTokenHeader,
  adAccountTerritoryDetails,
  fetchAdAccountData,
  isSimplifiedFlow,
  setIsSimplifiedFlow,
  convLoading,
  selectedCompany,
  ///setDialogOpen,
}) => {
  const handleDisagree = (): void => {
    setIsSimplifiedFlow(false);
    setAdAccountDetails([]);
    handleClose();
    setAdAccountId("");
    setCreateAccRes(false);
    handleCloseRetrieve();
    setSelectedSource("");
  };
  const handleBack = () => {
    setAdAccountDetails([]);
    setAdAccLength(true);
    setCreateAccRes(false);
    handleClose();
  };

  const [loading, setLoading] = useState(false);
  const [geoSelected, setGeoSelected] = useState("");
  const [industryTyped, setIndustryTyped] = useState("");
  const [industrySelected, setIndustrySelected] = useState("");
  const [, setTerritorySelected] = useState("");
  const [taxationAmount, setTaxationAmount] = useState(0.0);
  const [disableGeo, setDisableGeo] = useState(false);
  const [newGeo, setNewGeo] = useState("");
  const [disableIndustry, setDisableIndustry] = useState(false);
  const [successSnackbarOpen, setSuccessSnackbarOpen] = useState(false);
  const [adAccCreateResponseData, setAdAccCreateResponseData] = useState<
    AdAccountCreateResponse[]
  >([]);
  const [errorTextWhileCreate, setErrorTextWhileCreate] = useState<
    errorTextWhileCreate[]
  >([]);
  const [, /* snackbarMessage */ setSnackbarMessage] = useState("");
  const [accountIdInput, setAccountIdInput] = useState("");
  const [accountNameInput, setAccountNameInput] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [dateOverlapError, setDateOverlapError] = useState(false);
  const [overlappingIndices, setOverlappingIndices] = useState<number[]>([]);
  const handleAddButtonClick = () => {
    setTaxationAmount((prevAmount: any) => {
      // Convert prevAmount to number, handling all possible cases
      let currentAmount = 0;

      if (typeof prevAmount === "number" && !isNaN(prevAmount)) {
        currentAmount = prevAmount;
      } else if (typeof prevAmount === "string" && prevAmount !== "") {
        const parsed = parseFloat(prevAmount);
        currentAmount = !isNaN(parsed) ? parsed : 0;
      }
      // If prevAmount is null, undefined, empty string, or NaN, currentAmount stays 0

      const newAmount = currentAmount + 0.1;
      return parseFloat(newAmount.toFixed(2));
    });
  };

  const handleMinusButtonClick = () => {
    setTaxationAmount((prevAmount: any) => {
      // Convert prevAmount to number, handling all possible cases
      let currentAmount = 0;

      if (typeof prevAmount === "number" && !isNaN(prevAmount)) {
        currentAmount = prevAmount;
      } else if (typeof prevAmount === "string" && prevAmount !== "") {
        const parsed = parseFloat(prevAmount);
        currentAmount = !isNaN(parsed) ? parsed : 0;
      }
      // If prevAmount is null, undefined, empty string, or NaN, currentAmount stays 0

      const newAmount = Math.max(0, currentAmount - 0.1); // Prevent negative values
      return parseFloat(newAmount.toFixed(2));
    });
  };
  const removeNewIndustry = () => {
    setDisableIndustry(false);
  };
  const removeNewGeo = () => {
    setDisableGeo(false);
  };
  async function createAdAccount() {
    const data = {
      account_id: isSimplifiedFlow
        ? Number(accountIdInput)
        : adAccountDetails?.data?.account_id,
      account_name: isSimplifiedFlow
        ? `${accountNameInput.trim()}`
        : `${adAccountDetails?.data?.account_name}`,
      account_taxation: Number(taxationAmount),
      geo: `${geoSelected || newGeo}`,
      industry: `${industrySelected || industryTyped}`,
      traffic_source: `${selectedSource}`,
      advertising_company_shared_uid: `${selectedCompany?.shared_uid}`,
    };
    try {
      setLoading(true);
      await advertisingAccountsEndPointLogic.createAdAccount(
        oauthTokenHeader,
        data,
        setErrorTextWhileCreate,
        setCreateAccRes,
        setAdAccCreateResponseData,
        trackPromise,
      );
      /* setCreateAccRes(true); */
    } catch (error) {
      console.error("Error fetching advertising accounts:", error);
    } finally {
      setLoading(false);
    }
  }

  const handleInputChange = (event: any) => {
    const value = event.target.value;

    if (value === "") {
      setTaxationAmount(0.0);
      return;
    }

    // Allow partial decimal input (e.g., "5.", "5.1", ".5")
    // Only validate if it's a valid number pattern
    const decimalPattern = /^-?\d*\.?\d*$/;

    if (decimalPattern.test(value)) {
      // If it ends with just a decimal point, keep the string for display
      if (value.endsWith(".") || value === "-") {
        setTaxationAmount(value);
      } else {
        const parsedValue = parseFloat(value);
        if (!isNaN(parsedValue)) {
          setTaxationAmount(parsedValue);
        }
      }
    }
  };

  const handleInputBlur = (event: any) => {
    const value = event.target.value;
    if (value === "" || value === "." || value === "-") {
      setTaxationAmount(0.0);
    } else {
      const parsedValue = parseFloat(value);
      if (!isNaN(parsedValue)) {
        setTaxationAmount(parsedValue);
      } else {
        setTaxationAmount(0.0);
      }
    }
  };

  const [divs, setDivs] = useState<DivItem[]>([
    {
      id: 1,
      assetType: "",
      assetName: "",
      startDate: dayjs(), // Set default to today
      endDate: dayjs("2029-01-01"), // Set default to 2029-01-01
      disabled: false,
    },
  ]);

  // Function to add a new div
  const addNewDiv = () => {
    setDivs([
      ...divs,
      {
        id: divs.length + 1,
        assetType: "",
        assetName: "",
        startDate: dayjs(), // Set default to today
        endDate: dayjs("2029-01-01"), // Set default to 2029-01-01
        disabled: false,
      },
    ]);
  };

  const handleAssetChange = <K extends keyof DivItem>(
    index: number,
    field: K,
    value: DivItem[K],
  ) => {
    const newDivs = [...divs];
    newDivs[index][field] = value;
    setDivs(newDivs);
  };
  const postWebsiteToAcc = useCallback(async () => {
    const formattedSites = divs.map((item) => {
      const matchedSite = siteNames.find(
        (site: any) => site.key === item.assetName,
      );

      return {
        website_shared_uid: matchedSite?.key || "", // Convert key back to site_name
        start_date: item?.startDate?.format("YYYY-MM-DD") || null,
        end_date: item?.endDate?.format("YYYY-MM-DD") || null,
      };
    });
    const data = {
      data: {
        sites: formattedSites,
      },
    };

    try {
      setLoading(true);
      const res = await advertisingAccountsEndPointLogic.postWebToAcc(
        oauthTokenHeader,
        data,
        adAccCreateResponseData?.[0]?.shared_uid,
      );
      return res;
    } catch (error) {
      console.error("Error posting websites to account:", error);
    } finally {
      setLoading(false);
    }
  }, [divs, oauthTokenHeader, adAccCreateResponseData, siteNames]);

  const handleAgree = async () => {
    if (geoSelected && industrySelected) {
      setLoading(true);
      try {
        setAdAccountId("");
        // await postGeo(); // Await the postGeo function
        //await postIndustry(); // Await the postIndustry function
        // // Await the postWebsiteToAcc function
        await createAdAccount(); // Await the createAdAccount function
      } catch (error) {
        console.error("Error during account creation process:", error);
        setSnackbarMessage(
          "An error occurred while creating the account. Please try again.",
        );
        setSuccessSnackbarOpen(true);
      } finally {
        setLoading(false);
      }
    } else {
      setSnackbarMessage("Input missing, Please try again");
      setSuccessSnackbarOpen(true);
    }
  };
  const postConvActions = async () => {
    const convActions = adAccountDetails?.data?.account_conv_actions || [];

    if (adAccCreateResponseData && convActions.length > 0) {
      const payload = {
        conversion_actions: convActions,
      };

      const res = await advertisingAccountsEndPointLogic.postAdAccountDetails(
        oauthTokenHeader,
        payload,
        adAccCreateResponseData[0]?.shared_uid,
      );
      return res;
    }
  };
  useEffect(() => {
    const handlePostAccountSetup = async () => {
      if (adAccCreateResponseData?.length > 0) {
        setReloadAfterToggleEdit(true);
        setErrorSnackbarOpen(true);

        if (isSimplifiedFlow) {
          // Simplified flow → only first API
          const res1 = await postWebsiteToAcc();
          if (res1 && res1?.status === 200) {
            handleClose();
            fetchAdAccountData();
          }
        } else {
          // Normal flow → both APIs
          const res1 = await postWebsiteToAcc();
          const res2 = await postConvActions();
          // res2 is undefined when there are no conversion actions, treat as success
          if (
            res1?.status === 200 &&
            (res2?.status === 200 || res2 === undefined)
          ) {
            handleClose();
            fetchAdAccountData();
          }
        }
      }
    };

    handlePostAccountSetup();
    // eslint-disable-next-line
  }, [adAccCreateResponseData?.length, setReloadAfterToggleEdit]);

  // Removed useEffect that was re-opening the dialog when errorSnackbarOpen was true.
  // This was fighting against handleClose() and preventing the popup from closing
  // after successful account creation.

  useEffect(() => {
    if (adAccountDetails) {
      setShowAlert(true);
      const timer = setTimeout(() => {
        setShowAlert(false);
      }, 3000); // 3000 ms = 3 seconds

      return () => clearTimeout(timer); // Clear the timeout if the component unmounts
    }
  }, [adAccountDetails]);

  useEffect(() => {
    if (successSnackbarOpen) {
      setSuccessSnackbarOpen(true);
      const timer = setTimeout(() => {
        setSuccessSnackbarOpen(false);
      }, 3000); // 3000 ms = 3 seconds

      return () => clearTimeout(timer); // Clear the timeout if the component unmounts
    }
  }, [successSnackbarOpen]);
  useEffect(() => {
    if (createAccRes) {
      setCreateAccRes(true);
      const timer = setTimeout(() => {
        setCreateAccRes(false);
      }, 3000); // 3000 ms = 3 seconds

      return () => clearTimeout(timer); // Clear the timeout if the component unmounts
    }
  }, [createAccRes, setCreateAccRes]);

  const [switchChecked, setSwitchChecked] = useState(true);
  const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSwitchChecked(event.target.checked);
  };
  /* const convActionsIds = adAccountDetails?.account_conv_actions?.map((a:any) => a.id) */
  const geoDropDown = adAccountGeoDetails?.map((a: any) => a.name);
  const territoryDropDown = adAccountTerritoryDetails?.map(
    (a: any) => a?.territory_name,
  );
  const industryDropDown = adAccountIndustryDetails?.map(
    (a: any) => a?.industry_name,
  );
  const dialogContentRef = useRef<HTMLDivElement>(null);

  const jsonString = errorTextWhileCreate[0]?.text;
  const jsonObject = jsonString && JSON.parse(jsonString);
  const reason = jsonObject?.reason;
  useEffect(() => {
    // Reset scroll position on component mount or dialog open
    if (dialogContentRef.current) {
      dialogContentRef.current.scrollTop = 0;
    }
    if ((successSnackbarOpen || createAccRes) && dialogContentRef?.current) {
      dialogContentRef?.current.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [successSnackbarOpen, createAccRes]);
  const isAssetValid = divs.every((div) => div.assetName.trim() !== "");
  const isIndividualDateInvalid = (
    startDate: Dayjs | null,
    endDate: Dayjs | null,
  ) => {
    if (!startDate || !endDate) return false;
    return dayjs(endDate).isBefore(dayjs(startDate), "day");
  };
  const isDateValid =
    divs?.every((div: any) => {
      if (!div?.startDate || !div?.endDate) {
        return false; // missing dates
      }
      if (!dayjs(div.startDate).isValid() || !dayjs(div.endDate).isValid()) {
        return false;
      }
      // Only invalid if endDate is strictly before startDate
      if (isIndividualDateInvalid(div.startDate, div.endDate)) {
        return false;
      }

      return true; // valid if same day or endDate after startDate
    }) && !dateOverlapError;

  const handleRemove = (indexToRemove: number) => {
    setDivs((prevDivs) => prevDivs.filter((_, i) => i !== indexToRemove));
  };
  const getAvailableSiteNames = (currentIndex: number) => {
    // Get all selected asset names except for the current dropdown
    const selectedAssetNames = divs
      .map((div, index) => (index !== currentIndex ? div.assetName : null))
      .filter(Boolean); // Remove null values

    // Filter out already selected assets
    return siteNames.filter(
      (site: any) => !selectedAssetNames.includes(site.key),
    );
  };

  const checkDateOverlaps = useCallback(
    (divItems: DivItem[]) => {
      const overlaps: number[] = [];

      for (let i = 0; i < divItems.length; i++) {
        for (let j = i + 1; j < divItems.length; j++) {
          const item1 = divItems[i];
          const item2 = divItems[j];

          // Skip if either item doesn't have both dates
          if (
            !item1.startDate ||
            !item1.endDate ||
            !item2.startDate ||
            !item2.endDate
          ) {
            continue;
          }

          // Check if date ranges overlap
          const start1 = item1.startDate;
          const end1 = item1.endDate;
          const start2 = item2.startDate;
          const end2 = item2.endDate;

          // Two ranges overlap if: start1 <= end2 && start2 <= end1
          const isOverlapping =
            start1.isSameOrBefore(end2) && start2.isSameOrBefore(end1);

          if (isOverlapping) {
            if (!overlaps.includes(i)) overlaps.push(i);
            if (!overlaps.includes(j)) overlaps.push(j);
          }
        }
      }

      setOverlappingIndices(overlaps);
      setDateOverlapError(overlaps.length > 0);

      // Show snackbar if overlaps detected
      if (overlaps.length > 0 && !successSnackbarOpen) {
        setSnackbarMessage("Date ranges cannot overlap between linked assets");
      }
    },
    [successSnackbarOpen, setSnackbarMessage],
  );

  useEffect(() => {
    if (divs.length > 1) {
      checkDateOverlaps(divs);
    } else {
      setDateOverlapError(false);
      setOverlappingIndices([]);
    }
  }, [divs, checkDateOverlaps]);
  return (
    <>
      {/* {loading ? (
        <SimpleBackdrop />
      ) : ( */}
      <Paper ref={dialogContentRef} sx={{ overflowY: "auto" }}>
        <DialogTitle id="responsive-dialog-title">
          {"Add New Account"}
        </DialogTitle>
        <DialogContent sx={{ overflowY: "auto" }}>
          <DialogContentText>
            {showAlert && (
              <Alert
                iconMapping={{
                  success: <CheckCircleOutlineIcon sx={{ color: "#1E4620" }} />,
                }}
                sx={{
                  height: "50%",
                  fontWeight: "500",
                  backgroundColor: "#EDF7ED",
                  color: "#1E4620",
                  display: "flex",
                  alignItems: "center",
                  padding: "0 4px",
                  border: "1px solid #2E7D3280",
                }}
                severity="success"
              >
                Account retrieved successfully!
              </Alert>
            )}
            {successSnackbarOpen && (
              <Alert
                sx={{
                  height: "50%",
                  fontWeight: "500",
                  display: "flex",
                  alignItems: "center",
                  padding: "0 4px",
                }}
                severity="warning"
              >
                Input missing, Please try again!
              </Alert>
            )}
            {createAccRes && (
              <Alert
                sx={{
                  height: "50%",
                  fontWeight: "500",
                  display: "flex",
                  alignItems: "center",
                  padding: "0 4px",
                }}
                severity="error"
              >
                {reason}
              </Alert>
            )}

            <div
              style={{
                display: "flex",
                paddingBottom: "16px",
                paddingTop: "16px",
                gap: "16px",
              }}
            >
              <TextField
                disabled
                id="outlined-disabled"
                label="Source"
                defaultValue={selectedSource}
                size="small"
                sx={{ width: "50%", background: "#0000000F" }}
              />
              <TextField
                disabled={!isSimplifiedFlow}
                id={isSimplifiedFlow ? undefined : "outlined-disabled"}
                color={isSimplifiedFlow ? "secondary" : undefined}
                label="ID at source"
                type={isSimplifiedFlow && "number"}
                value={
                  isSimplifiedFlow
                    ? accountIdInput
                    : adAccountDetails?.data?.account_id || "N/A"
                }
                onChange={(e) =>
                  isSimplifiedFlow && setAccountIdInput(e.target.value)
                }
                size="small"
                sx={{
                  width: "50%",
                  background: isSimplifiedFlow ? "#FFFFFF" : "#0000000F",
                }}
              />
            </div>
            <div
              style={{ display: "flex", paddingBottom: "16px", gap: "16px" }}
            >
              <TextField
                disabled={!isSimplifiedFlow}
                id={isSimplifiedFlow ? undefined : "outlined-disabled"}
                color={isSimplifiedFlow ? "secondary" : undefined}
                label="Account Name"
                value={
                  isSimplifiedFlow
                    ? accountNameInput
                    : adAccountDetails?.data?.account_name || "N/A"
                }
                onChange={(e) =>
                  isSimplifiedFlow && setAccountNameInput(e.target.value)
                }
                size="small"
                sx={{
                  width: "49%",
                  background: isSimplifiedFlow ? "#FFFFFF" : "#0000000F",
                }}
              />
              <TextField
                id="outlined-disabled"
                size="small"
                sx={{ width: "318px" }}
                color="secondary"
                label="Taxation"
                onBlur={handleInputBlur}
                value={taxationAmount}
                onChange={handleInputChange}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <PercentIcon sx={{ marginLeft: "12px" }} />
                    </InputAdornment>
                  ),
                }}
              />
              <AddIcon
                onClick={handleAddButtonClick}
                cursor="pointer"
                color="secondary"
                sx={{ marginLeft: "5px", marginTop: "6px" }}
              />
              <RemoveIcon
                onClick={handleMinusButtonClick}
                cursor="pointer"
                color="secondary"
                sx={{ marginLeft: "5px", marginTop: "6px" }}
              />
            </div>
            <div style={{ display: "flex", paddingBottom: "16px" }}>
              <div>
                <Autocomplete
                  disabled={disableGeo}
                  options={geoDropDown}
                  onChange={(_, newValue: any) => {
                    setGeoSelected(newValue);
                  }}
                  renderOption={(account, option: any, { selected }) => (
                    <Box
                      component="li"
                      {...account}
                      sx={{
                        backgroundColor: selected
                          ? "#F7EEF9 !important"
                          : "inherit",
                      }}
                    >
                      {option}
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Geo *"
                      placeholder="Please select a Geo from the list."
                      InputProps={{
                        ...params.InputProps,
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon sx={{ marginLeft: "12px" }} />
                          </InputAdornment>
                        ),
                      }}
                      color="secondary"
                    />
                  )}
                  size="small"
                  sx={{ width: "430px", paddingRight: "16px" }}
                />
                {disableGeo && (
                  <>
                    <div
                      style={{
                        display: "flex",
                        paddingBottom: "16px",
                        paddingTop: "16px",
                      }}
                    >
                      <TextField
                        id="outlined-disabled"
                        label="New Geo"
                        value={newGeo}
                        onChange={(e) => setNewGeo(e.target.value)}
                        size="small"
                        sx={{ width: "40%" }}
                      />
                      <Autocomplete
                        options={territoryDropDown}
                        onChange={(_, newValue: any) => {
                          setTerritorySelected(newValue);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Territory *"
                            placeholder="Please select an industry from the list."
                            InputProps={{
                              ...params.InputProps,
                              startAdornment: (
                                <InputAdornment position="start"></InputAdornment>
                              ),
                            }}
                            color="secondary"
                          />
                        )}
                        size="small"
                        sx={{ width: "40%", marginLeft: "15px" }}
                      />
                      <Button onClick={removeNewGeo} color="secondary">
                        <CloseOutlinedIcon color="secondary" />
                      </Button>
                    </div>
                  </>
                )}
              </div>
              <div>
                <Autocomplete
                  disabled={disableIndustry}
                  options={industryDropDown}
                  onChange={(_, newValue: any) => {
                    setIndustrySelected(newValue);
                  }}
                  renderOption={(account, option: any, { selected }) => (
                    <Box
                      component="li"
                      {...account}
                      sx={{
                        backgroundColor: selected
                          ? "#F7EEF9 !important"
                          : "inherit",
                      }}
                    >
                      {option}
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Industry *"
                      placeholder="Please select an industry from the list."
                      InputProps={{
                        ...params.InputProps,
                        startAdornment: (
                          <InputAdornment position="start"></InputAdornment>
                        ),
                      }}
                      color="secondary"
                    />
                  )}
                  size="small"
                  sx={{ width: "418px" }}
                />
                {disableIndustry && (
                  <>
                    <TextField
                      id="outlined-disabled"
                      label="Add new Industry"
                      value={industryTyped}
                      onChange={(e) => setIndustryTyped(e.target.value)}
                      size="small"
                      sx={{ width: "80%", marginTop: "12px" }}
                    />
                    <Button
                      onClick={removeNewIndustry}
                      color="secondary"
                      sx={{ marginTop: "14px" }}
                    >
                      <CloseOutlinedIcon
                        color="secondary"
                        sx={{ padding: "0px" }}
                      />
                    </Button>
                  </>
                )}
              </div>
            </div>

            <FormHelperText sx={{ marginBlock: "16px" }}>
              All fields are mandatory.
            </FormHelperText>
            <FormHelperText
              sx={{ marginBlock: "16px", fontSize: "16px", color: "#000000" }}
            >
              Linked Asset{" "}
            </FormHelperText>
            <div>
              <Grid container>
                {divs.map((item, index) => (
                  <Grid
                    container
                    key={item.id}
                    alignItems="center"
                    columnSpacing={2}
                    wrap="nowrap"
                    sx={{ marginBottom: 2 }}
                  >
                    {/* Asset Type Autocomplete */}
                    <Grid item xs={12} sm={3}>
                      <Autocomplete
                        options={["website"]}
                        value={"website"}
                        onChange={(_, newValue) =>
                          handleAssetChange(index, "assetType", newValue || "")
                        }
                        renderInput={(params) => (
                          <TextField
                            required
                            {...params}
                            label="Asset type"
                            placeholder="Select type from the list."
                            color="secondary"
                          />
                        )}
                        size="small"
                        sx={{ width: "100%" }}
                      />
                    </Grid>

                    {/* Asset Name Autocomplete */}
                    <Grid item xs={12} sm={5}>
                      <Autocomplete
                        disabled={item.disabled}
                        value={
                          siteNames.find(
                            (site: any) => site.key === item.assetName,
                          ) || null
                        }
                        options={getAvailableSiteNames(index)} // Pass full site objects
                        getOptionLabel={(option: any) =>
                          option.site.ui_site_name
                        } // Display name
                        onChange={(_, newValue: any) =>
                          handleAssetChange(
                            index,
                            "assetName",
                            newValue?.key || "",
                          )
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            required
                            label="Asset name"
                            placeholder="Please search or select an asset from the list."
                            color="secondary"
                            InputProps={{
                              ...params.InputProps,
                              startAdornment: (
                                <InputAdornment position="start">
                                  <SearchIcon sx={{ marginLeft: "12px" }} />
                                </InputAdornment>
                              ),
                            }}
                          />
                        )}
                        size="small"
                        sx={{ width: "100%" }}
                      />
                    </Grid>

                    {/* Date Range Picker */}
                    <Grid item xs={12} sm={4}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DateRangePicker
                          slots={{ field: SingleInputDateRangeField }}
                          value={[item.startDate, item.endDate]}
                          onChange={(newValue) => {
                            handleAssetChange(
                              index,
                              "startDate",
                              newValue?.[0] || null,
                            );
                            handleAssetChange(
                              index,
                              "endDate",
                              newValue?.[1] || null,
                            );
                          }}
                          format="DD-MM-YYYY"
                          name="allowedRange"
                          slotProps={{
                            textField: {
                              size: "small",
                              fullWidth: true,
                              color: "secondary",
                              error:
                                overlappingIndices.includes(index) ||
                                isIndividualDateInvalid(
                                  item.startDate,
                                  item.endDate,
                                ),
                              helperText: (() => {
                                if (
                                  isIndividualDateInvalid(
                                    item.startDate,
                                    item.endDate,
                                  )
                                ) {
                                  return "Invalid date range";
                                }
                                if (overlappingIndices.includes(index)) {
                                  return "Date range overlaps with another asset";
                                }
                                return "";
                              })(),
                              FormHelperTextProps: {
                                sx: {
                                  fontSize: "0.73rem",
                                  margin: "0px !important",
                                },
                              },
                              sx: {
                                "& .MuiOutlinedInput-root": {
                                  "&.Mui-error": {
                                    "& fieldset": {
                                      borderColor: "#d32f2f",
                                      borderWidth: "1px",
                                    },
                                  },
                                },
                              },
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </Grid>
                    {index > 0 && (
                      <Grid item xs="auto">
                        <IconButton
                          color="secondary"
                          onClick={() => handleRemove(index)}
                          sx={{ marginTop: "-4px" }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Grid>
                    )}
                  </Grid>
                ))}
              </Grid>

              <Typography fontSize={12} sx={{ marginBlock: "8px 6px" }}>
                More than one linked asset?
              </Typography>
              <Button variant="outlined" color="secondary" onClick={addNewDiv}>
                Add New
              </Button>
            </div>

            <FormControlLabel
              control={
                <Switch
                  disabled
                  color="success"
                  checked={switchChecked}
                  onChange={handleSwitchChange}
                />
              }
              label="Account Status"
            />
            <Stack
              padding={1}
              marginY={2}
              direction="row"
              alignItems="center"
              spacing={1}
            >
              <Typography style={{ fontSize: "1rem" }}>
                Conversion Actions
              </Typography>
              <Button
                onClick={() => getAdAccountDetailsByClick()}
                disabled={isSimplifiedFlow}
                color="secondary"
                sx={{
                  border: "none", // Removes the border
                  "&:hover": {
                    border: "none", // Ensures no border on hover as well
                  },
                }}
              >
                {convLoading ? (
                  <CircularProgress color="secondary" size={20} />
                ) : (
                  <ReplayOutlinedIcon
                    color={isSimplifiedFlow ? "disabled" : "secondary"}
                  />
                )}
              </Button>
            </Stack>
            {adAccountDetails?.data?.account_conv_actions?.map((data: any) => (
              <div
                style={{
                  display: "flex",
                  paddingBottom: "16px",
                  gap: "16px",
                }}
              >
                <TextField
                  disabled
                  id="outlined-disabled"
                  label="Action name"
                  defaultValue={data?.id}
                  size="small"
                  sx={{ width: "225px", background: "#0000000F" }}
                />
                <TextField
                  disabled
                  id="outlined-disabled"
                  label="Action ID at source"
                  defaultValue={data?.action}
                  size="small"
                  sx={{ width: "600px", background: "#0000000F" }}
                />
              </div>
            ))}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ padding: "0px 24px 20px 24px" }}>
          <Button
            autoFocus
            onClick={handleDisagree}
            disabled={loading}
            sx={{
              color: "#9C27B0",
              "&:hover": { background: "#ffffff", color: "#9C27B0" },
            }}
          >
            CANCEL
          </Button>
          <Button
            variant="outlined"
            color="secondary"
            onClick={handleBack}
            disabled={loading}
          >
            <ChevronLeftIcon />
            BACK
          </Button>
          <Button
            variant="outlined"
            data-tracker="185"
            onClick={handleAgree}
            disabled={
              isSimplifiedFlow
                ? !accountIdInput ||
                  !accountNameInput ||
                  !geoSelected ||
                  loading ||
                  !industrySelected ||
                  !isAssetValid ||
                  !isDateValid
                : !isAssetValid ||
                  loading ||
                  !isDateValid ||
                  !geoSelected ||
                  !industrySelected
            }
            autoFocus
            color="secondary"
            endIcon={
              loading ? <CircularProgress size={16} color="inherit" /> : null
            }
          >
            {loading ? "Creating..." : "Create Account"}
          </Button>
        </DialogActions>
      </Paper>
      {/* )} */}
    </>
  );
};

export default CreateAccountDialog;
